export default "__VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__"